module.exports = __webpack_public_path__ + "img/logo-stirpe.a3e23e0f.svg";